import ar from '@/local/ar';
import Vue from '@/main';
import { setLookupInLocalStorage, setSubLookupInLocalStorage } from '../helpers/utils';
import api from '../services/api';

export default {
  getCountries(store) {
    return getData(store, 'countries', 'getCountries', 'الدول');
  },
  getCities(store) {
    return getData(store, 'cities', 'getCities', 'المدن');
  },
  getCitiesByRegion(store, payload) {
    return getDataByRelatedId(store, payload, 'subCities', 'getCitiesByRegion', 'المدن');
  },
  getDistrictsByCity(store, payload) {
    return getDataByRelatedId(store, payload, 'districts', 'getDistrictsByCity', 'الاحياء');
  },
  getRegions(store) {
    return getData(store, 'regions', 'getRegions', 'المناطق');
  },
  getCentersByCity(store, payload) {
    return getDataByRelatedId(store, payload, 'centers', 'getCentersByCity', 'المراكز');
  },
  getPublicAndPersonalStatusCourts(store) {
    return getData(store, 'publicAndPersonalStatusCourts', 'getPublicAndPersonalStatusCourts', 'المحاكم العامة و الإحوال الشخصية');
  },
  getCaseTypesByCategory(store, payload) {
    return getDataByRelatedId(store, payload, 'caseTypesByCategory', 'getCaseTypesByCategory', 'انواع الدعوى');
  },
  getUserCaseClassifications(store) {
    return getData(store, 'userCaseClassifications', 'getUserCaseClassifications', 'تصنيفات الدعوى الرئيسية');
  },
  getCaseTypeTree(store) {
    return getData(store, 'caseTypeTree', 'getCaseTypeTree', 'شجرة انواع الدعاوى');
  },
  getUserCaseCategories(store, payload) {
    return getDataByRelatedId(store, payload, 'userCaseCategories', 'getUserCaseCategories', 'تصنيفات الدعوى الفرعية');
  },
  getUserCaseTypes(store, payload) {
    return getDataByRelatedId(store, payload, 'userCaseTypes', 'getUserCaseTypes', 'أنواع الدعوى');
  },
  getSubLanguages(store, payload) {
    return getDataByRelatedId(store, payload, 'subLanguages', 'getSubLanguages', 'اللغات الفرعية');
  },
  getMainSubLanguageDetailsById(store, payload) {
    return getDataByRelatedId(store, payload, 'mainSubLanguageDetails', 'getMainSubLanguageDetailsById', 'تفاصيل اللغة');
  },
  getMinorCases(store) {
    return getData(store, 'minorCases', 'getMinorCases', 'حالات القاصر');
  },
  getRelatives(store) {
    return getData(store, 'relatives', 'getRelatives', 'صلات القرابة');
  },
  getInstrumentSources(store) {
    return getData(store, 'instrumentSources', 'getInstrumentSources', 'مصادر الصك');
  },
  getAttachmentCategories(store) {
    return getData(store, 'attachmentCategories', 'getAttachmentCategories', 'أنواع المرفق');
  },
  getWorkPlaces(store) {
    return getData(store, 'workPlaces', 'getWorkPlaces', 'جهات العمل');
  },
  getGovernmentAgencies(store) {
    return getData(store, 'governmentAgencies', 'getGovernmentAgencies', 'الجهات الحكومية');
  },
  getAssociations(store) {
    return getData(store, 'associations', 'getAssociations', 'الجمعيات');
  },
  getEmbassies(store) {
    return getData(store, 'embassies', 'getEmbassies', 'القنصليات');
  },
  getPrisons(store) {
    return getData(store, 'prisons', 'getPrisons', 'السجون');
  },
  getPrisonerStatuses(store) {
    return getData(store, 'prisonerStatuses', 'getPrisonerStatuses', 'حالات السجين');
  },
  getSocialTypesWithCommercialReg(store) {
    return getData(store, 'socialTypesWithCommercialReg', 'getSocialTypesWithCommercialReg', 'أنواع الهوية');
  },
  getSocialTypes(store) {
    return getData(store, 'socialTypes', 'getSocialTypes', 'أنواع الهوية');
  },
  getCessationTypes(store) {
    return getData(store, 'cessationTypes', 'getCessationTypes', 'أنواع الوقف');
  },
  getPartyTypes(store) {
    return getData(store, 'partyTypes', 'getPartyTypes', 'أنواع الفرد');
  },
  getPartyReferences(store) {
    return getData(store, 'partyReferences', 'getPartyReferences', 'صفات الفرد');
  },
  getCourtSubCircles(store, payload) {
    return getDataByRelatedId(store, payload, 'courtSubCircles', 'getCourtSubCircles', 'الدوائر');
  },
  getAllCourtSubCircles(store, payload) {
    return getDataByRelatedId(store, payload, 'allCourtSubCircles', 'getAllCourtSubCircles', 'الدوائر');
  },
  getRejectionReasons(store, payload) {
    return getDataByRelatedId(
      store,
      payload,
      'rejectionReasons',
      'getRejectionReasons',
      'أسباب الرفض'
    );
  },
  getCitiesByCourtType(store, payload) {
    return getDataByRelatedId(store, payload, 'citiesByCourtType', 'getCitiesByCourtType', 'المدن');
  },
  getPersonalCityCourtByType(store, payload) {
    return getDataByRelatedId(store, payload, 'cityCourtByType', 'getPersonalCityCourtByType', 'المحاكم');
  },
  getCriminalCityCourtByType(store, payload) {
    return getDataByRelatedId(store, payload, 'criminalCityCourtByType', 'getCriminalCityCourtByType', 'المحاكم');
  },
  getGeneralCityCourtByType(store, payload) {
    return getDataByRelatedId(store, payload, 'cityCourtByType', 'getGeneralCityCourtByType', 'المحاكم');
  },
  getAllCourts(store) {
    return getData(store, 'allCourts', 'getAllCourts', 'المحاكم');
  },
  getMergedActiveCourts(store) {
    return getData(store, 'mergedActiveCourts', 'getMergedActiveCourts', 'المحاكم');
  },
  getLawsuitEmployees(store) {
    return getData(store, 'lawsuitEmployees', 'getLawsuitEmployees', 'الموظفين');
  },
  getServicesCenterEmployees(store, employeeType) {
    return getDataByRelatedId(
      store,
      employeeType,
      'servicesCenterEmployees',
      'getServicesCenterEmployees',
      'الموظفين'
    );
  },
  getCentralAuditEmployees(store) {
    return getData(store, 'centralAuditEmployees', 'getCentralAuditEmployees', 'الموظفين');
  },
  getAuditPaths(store) {
    return getData(store, 'auditPaths', 'getAuditPaths', 'المسارات');
  },
  getGovernmentalOrganizations(store) {
    return getData(
      store,
      'governmentalOrganizations',
      'getGovernmentalOrganizations',
      'جهات الورود'
    );
  },
  getLanguages(store) {
    return getData(store, 'languages', 'getLanguages', 'اللغات');
  },
  getContractTypes(store) {
    return getData(store, 'contractTypes', 'getContractTypes', 'أنواع العقد');
  },
  getSalaryPaymentIntervals(store) {
    return getData(store, 'salaryPaymentIntervals', 'getSalaryPaymentIntervals', 'أنواع الأجر');
  },
  getContractDropReasons(store) {
    return getData(store, 'contractDropReasons', 'getContractDropReasons', 'أسباب ترك العمل');
  },
  getLaborRequests(store) {
    return getData(store, 'laborRequests', 'getLaborRequests', 'الطلبات العمالية');
  },
  getReconciliationLocations(store) {
    return getData(store, 'reconciliationLocations', 'getReconciliationLocations', 'مراكز المصالحة');
  },
  getLaborRequestFormFields(store, payload) {
    const mapper = data =>
      data.fields.map(f => ({
        ...f,
        if: (JSON.parse(f.properties) || {}).if || true,
        column: (JSON.parse(f.properties) || {}).column,
        validations: (JSON.parse(f.properties) || {}).validations,
      }));
    return getDataByRelatedId(
      store,
      payload,
      'laborRequestFormFields',
      'getLaborRequestsForm',
      'حقول الطلب',
      mapper
    );
  },
  getLaborEvidences(store) {
    return getData(store, 'laborEvidences', 'getLaborEvidences', 'البينات');
  },
  getLaborEvidenceFormFields(store, payload) {
    const mapper = data =>
      data.fields.map(f => ({
        ...f,
        column: (JSON.parse(f.properties) || {}).column,
        validations: (JSON.parse(f.properties) || {}).validations,
      }));
    return getDataByRelatedId(
      store,
      payload,
      'laborEvidenceFormFields',
      'getLaborEvidencesForm',
      'حقول البينة',
      mapper
    );
  },
  getCourtReplyTypes(store) {
    return getData(store, 'courtReplyTypes', 'getCourtReplyTypes', 'انواع الرد');
  },
  getMainLanguages(store) {
    return getData(store, 'mainLanguages', 'getMainLanguages', 'اللغات الرئيسية');
  },
  getCourts({ commit }) {
    return api
      .getCourts()
      .then((res) => {
        const data = res.data;

        commit('update', {
          key: 'courts',
          data,
        });
        setLookupInLocalStorage('courts', data);
      });
  },
  getDiplomaticAuthorities(store) {
    return getData(store, 'diplomaticAuthorities', 'getDiplomaticAuthorities', 'الجهات المركزية');
  },
  getSubAuthoritiesByCentralAuthorityId(store, payload) {
    return getDataByRelatedId(store, payload, 'subAuthorities', 'getSubAuthoritiesByCentralAuthorityId', 'الجهات الفرعية');
  },
  getCentralAuthoritiesForMinistries(store, payload) {
    return getDataByRelatedId(store, payload, 'centralAuthoritiesForMinistries', 'getCentralAuthoritiesForMinistries', 'الجهات المركزية لجهة عمل عسكرية');
  },
  getLaborCities(store) {
    return getData(store, 'laborCities', 'getLaborCities', 'المدن العمالية');
  },
  getCourtByLaborCity(store, payload) {
    return getDataByRelatedId(store, payload, 'laborCityCourt', 'getCourtByLaborCity', 'المحاكم العمالية');
  },
  getCaseRequestTypes(store) {
    return getData(store, 'caseRequestTypes', 'getCaseRequestTypes', 'انواع الطلبات في القضايا');
  },
  getAllCaseTypes(store) {
    return getData(store, 'allCaseTypes', 'getAllCaseTypes', 'انواع القضايا');
  },
  getPortalPartyRoles(store) {
    return getData(store, 'portalPartyRoles', 'getPortalPartyRoles', 'انواع الاطراف');
  },
  getPortalRequestStatus(store) {
    return getData(store, 'portalRequestStatus', 'getPortalRequestStatus', 'حالات الطلبات');
  },
  getDecisionTypes(store) {
    return getData(store, 'decisionTypes', 'getDecisionTypes', 'انواع القرارات');
  },
  getPartyAttributesPartyRoles(store) {
    return getData(store, 'partyAttributesPartyRoles', 'getPartyAttributesPartyRoles', 'أدوار الأطراف');
  },
  getIncomingRequestsTypes(store) {
    return getData(store, 'incomingRequestTypes', 'getIncomingRequestsTypes', 'انواع القرارات');
  },
  getCriminalCaseTypes(store) {
    return getData(store, 'criminalCaseTypes', 'getCriminalCaseTypes', 'انواع القضايا');
  },
  getRequestStatus(store) {
    return getData(store, 'requestStatus', 'getRequestStatus', 'حالات الطلبات');
  },
  getCassationRequestReasons(store) {
    return getData(store, 'cassationRequestReasons', 'getCassationRequestReasons', 'أسباب طلب النقض');
  },
};

const getData = ({ commit, state }, key, apiService, error, mapper = data => data, storeInLocalStorage = true) => {
  if (!state[key].length) {
    commit('update', {
      key,
      data: [],
    });
    return api[apiService]()
      .then((res) => {
        const data = mapper(res.data);
        commit('update', {
          key,
          data,
        });
        if (storeInLocalStorage) setLookupInLocalStorage(key, data);
        return data;
      })
      .catch(() => {
        Vue.toaster.error(ar.errors.wentWrongWhile(error));
        return [];
      });
  } else {
    return Promise.resolve(state[key]);
  }
};

const getDataByRelatedId = (
  { commit, state },
  relatedId,
  key,
  apiService,
  error,
  mapper = data => data,
  storeInLocalStorage = true
) => {
  if (relatedId) {
    if (!state[key][relatedId] || !state[key][relatedId].length) {
      return api[apiService](relatedId)
        .then((res) => {
          const data = mapper(res.data);
          commit('updateSubLookup', {
            relatedId,
            key,
            data,
          });
          if (storeInLocalStorage) setSubLookupInLocalStorage(relatedId, key, data);
          return data;
        })
        .catch(() => {
          Vue.toaster.error(ar.errors.wentWrongWhile(error));
          return [];
        });
    } else {
      return Promise.resolve(state[key][relatedId]);
    }
  } else {
    return Promise.resolve([]);
  }
};
